import { ImageSourcePropType } from 'react-native';

export enum LLThemeType {
  DARK = 'dark',
  LIGHT = 'light',
}

export type LLTheme = {
  text: string;
  secondaryText: string;
  background: string;
  secondaryBackground: string;
  popoverBackground: string;
  primaryButtonBackground: string;
  primaryPressedButtonBackground: string;
  primaryButtonText: string;
  border: string;
  info: string;
  error: string;
  widgetBackground: string;
  widgetOption: string;
  widgetSelectedOption: string;
  disabledButtonBackground: string;
  disabledButtonText: string;
  correct: string;
  incorrect: string;
  correctIncorrectText: string;
};

export type LLThemes = Record<LLThemeType, LLTheme>;

export type LLThemeAssets = {
  avatar: ImageSourcePropType;
  send: ImageSourcePropType;
  gif: ImageSourcePropType;
  sticker: ImageSourcePropType;
  close: ImageSourcePropType;
  bin: ImageSourcePropType;
  blockUser: ImageSourcePropType;
  flag: ImageSourcePropType;
  reaction: ImageSourcePropType;
  themeSwitch: ImageSourcePropType;
};
